import { render } from "./workExperience.vue?vue&type=template&id=60eb42a1"
import script from "./workExperience.vue?vue&type=script&lang=js"
export * from "./workExperience.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__